import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import Text from "./Text";
import CartImage from "./CartImage";
import ArrowIcon from "./ArrowIcon";
import locales from "../locales";

const CartContainerTitle = styled(Text)`
  margin-bottom: 8px !important;
  font-weight: 700 !important;
`;

const Wrap = styled.div`
  border-radius: 8px;
  width: 100%;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.palette.grey.neutral};

  .CartContainer {
    display: flex;
    gap: 8px;
  }
  .CartSummaryContainer {
    width: 100%;
    padding-top: 4px;
  }
  .CartSummary {
    padding-top: 4px;
    display: flex;
    align-items: center;
  }
  .CartSummaryQuantity {
    flex: 1;
  }
  .CartSummaryTotal {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 0;
    font: inherit;
    text-align: left;
  }
  .hidden {
    display: none;
  }
`;

const Cart = ({ merchantName, merchantLogo, quantity, total, children }) => {
  const intl = useIntl();

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <CartContainerTitle heading5>
        {intl.formatMessage(locales.cart_summary)}
      </CartContainerTitle>
      <Wrap>
        <div className="CartContainer">
          <div>
            <CartImage
              merchantLogo={merchantLogo}
              merchantName={merchantName}
            />
          </div>
          <div className="CartSummaryContainer">
            <Text primary body2>
              {merchantName}
            </Text>
            <div className="CartSummary">
              <div className="CartSummaryQuantity">
                <Text primary body2>
                  {quantity}{" "}
                  {intl.formatMessage(locales.shopper_quantity_suffix, {
                    quantity,
                  })}
                </Text>
              </div>
              <button
                type="button"
                className="CartSummaryTotal"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                <Text right cta_l body2>
                  {intl.formatMessage(locales.cart_total, {
                    totalAmount: total,
                  })}
                </Text>
                <ArrowIcon
                  isExpanded={isExpanded}
                  data-testid="cart-arrow-icon"
                />
              </button>
            </div>
          </div>
        </div>
        <div className={isExpanded ? "" : "hidden"}>{children}</div>
      </Wrap>
    </>
  );
};

Cart.propTypes = {
  merchantName: PropTypes.string,
  merchantLogo: PropTypes.string,
  quantity: PropTypes.number,
  total: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Cart.defaultProps = {
  merchantName: "",
  merchantLogo: "",
  quantity: 0,
  total: "",
};

export default Cart;
